import { StoppageTypeDto } from "./StoppageTypeDto";

export class StoppageSubTypeDto {
  stoppageSubTypeId?: number;
  stoppageTypeId!: number;
  stoppageSubType!: string
  stoppageType?: StoppageTypeDto;

  constructor(data: Partial<StoppageSubTypeDto>) {
    Object.assign(this, data);
  }
}